export default "/assets/images/filter-recommandation-BB.6e4818d6409c079b.jpg";